<div class="behavior-preview">
  <nz-alert
    [nzType]="hasValidConfig ? 'info' : 'default'"
    [nzMessage]="'Preview do Comportamento'"
    [nzDescription]="previewText"
    [nzShowIcon]="true">
  </nz-alert>

  <div class="preview-details" *ngIf="eventConfig && hasValidConfig">
    <nz-descriptions nzBordered nzSize="small">
      <nz-descriptions-item [nzTitle]="'builderScreen.events.preview.eventType' | translateTA">
        <nz-tag [nzColor]="eventConfig.eventType === 'onChange' ? 'blue' : 'green'">
          {{ eventConfig.eventType === 'onChange' ? 'Ao Mudar' : 'Ao Inicializar' }}
        </nz-tag>
      </nz-descriptions-item>

      <nz-descriptions-item [nzTitle]="'builderScreen.events.preview.mode' | translateTA" *ngIf="eventConfig.mode">
        <nz-tag [nzColor]="eventConfig.mode === 'simple' ? 'blue' : 'orange'">
          {{ eventConfig.mode === 'simple' ? 'Simples' : 'Expert' }}
        </nz-tag>
      </nz-descriptions-item>

      <nz-descriptions-item [nzTitle]="'builderScreen.events.preview.conditions' | translateTA" *ngIf="eventConfig.simpleConditions">
        {{ eventConfig.simpleConditions.length }} condição(ões)
      </nz-descriptions-item>

      <nz-descriptions-item [nzTitle]="'builderScreen.events.preview.actions' | translateTA" *ngIf="eventConfig.simpleActions">
        {{ eventConfig.simpleActions.length }} ação(ões)
      </nz-descriptions-item>
    </nz-descriptions>
  </div>
</div>



